import { AxiosError } from "axios";
import { PaginateQuery, PaginateResult } from "core/resources/types/shared";
import http from "infra/http";
import { useQuery } from "react-query";
import { GrupoDescontoListResponse } from "../typings";

function useGruposDesconto(query: PaginateQuery, tenantId: string) {
  return useQuery<PaginateResult<GrupoDescontoListResponse>, AxiosError>(
    [`/v1/grupo-desconto`, query, tenantId],
    async () => {
      const { data } = await http.get("/v1/grupo-desconto", {
        params: query,
        headers: {
          tenant: tenantId,
        },
      });

      return data;
    }
  );
}

export default useGruposDesconto;
